// components/forms/Step3Form.tsx
import React, { useState } from "react";
import { ValuationFormValues } from "@/store/valuationFormStore";
import { useValuationFormStore } from "@/store/valuationFormStore";
import { useFormContext } from "react-hook-form";
import ComparativeAnalysis from "@/components/ComparativeAnalysis";
import PropertyMap from "@/components/map/PropertyMap";
import { uploadToCloudinary } from "@/utils/uploadToCloudinary";
import MasterPlan from "@/components/masterplan";

const Step3Form: React.FC = () => {
  const {
    register,
    formState: { errors },
    setValue,
    watch,
  } = useFormContext<ValuationFormValues>();
  const { formData } = useValuationFormStore();
  const [uploadingField, setUploadingField] = useState<string | null>(null);

  console.log(formData.latitude, formData.longitude);
  const handleFileChange = async (
    // eslint-disable-next-line no-undef
    e: React.ChangeEvent<HTMLInputElement>,
    field: any
  ) => {
    const file = e.target.files?.[0];
    if (!file) return;

    setUploadingField(field);
    try {
      const imageUrl = await uploadToCloudinary(file);
      setValue(field, imageUrl);
    } catch (err) {
      console.error(err);
      alert("Upload failed. Please try again.");
    } finally {
      setUploadingField(null);
    }
  };
  console.log("formData:---", formData);
  return (
    <div className="space-y-6 p-6">
      <h2 className="text-xl font-semibold text-gray-900 mb-4">
        Property Photos
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-2">
        {[
          { label: "Upload Front View", name: "frontView" },
          { label: "Upload Back View", name: "backView" },
          { label: "Upload Left Side View", name: "leftView" },
          { label: "Upload Right Side View", name: "rightView" },
          { label: "Upload Living Room View", name: "livingRoom" },
          { label: "Upload Kitchen", name: "kitchen" },
          { label: "Upload Bed Room", name: "bedroom" },
          { label: "Upload Bath Room", name: "bathroom" },
          { label: "Upload Dining Room", name: "diningRoom" },
          // { label: "Upload Veranda", name: "veranda" },
          { label: "Upload google earth image", name: "googleEarthOne" },
          {
            label: "Upload google earth close-up image",
            name: "googleEarthTwo",
          },
          { label: "Upload masterPlan image", name: "masterPlan" },
        ].map(({ label, name }: any) => {
          return (
            <div key={name}>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                {label}
              </label>
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleFileChange(e, name)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              {uploadingField === name && (
                <p className="text-sm text-blue-500 mt-1">Uploading...</p>
              )}

              {watch(name) && (
                <div className="mt-2">
                  <img
                    src={
                      typeof watch(name) === "string"
                        ? watch(name)
                        : watch(name)?.url
                    }
                    alt={name}
                    className="w-32 h-32 object-cover rounded"
                  />
                  <p className="text-xs text-green-600 break-all mt-1">
                    Uploaded:{" "}
                    {typeof watch(name) === "string"
                      ? watch(name)
                      : watch(name)?.url || "Uploaded successfully"}
                  </p>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* <PropertyMap
        Upi={formData.upi || ""}
        location={[
          formData.latitude || 1.88596,
          formData.longitude || 30.129675,
        ]}
      /> */}

      {/* <div className="grid grid-cols-1 gap-4 md:gap-8">
        <iframe
          src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.979567234864!2d${
            formData.latitude || 1.88596
          }!3d${
            formData.longitude || 30.129675
          }!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjM6MTM0!5e0!3m2!1sen!2sng!4v1680879000000!5m2!1sen!2sng`}
          width="100%"
          height="500"
          style={{ border: 0 }}
          allowFullScreen={false}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
        <iframe
          src="https://masterplan.kigalicity.gov.rw/portal/apps/webappviewer/index.html?id=fdd2e30cbc15401d9daee5f68982d755 "
          width="100%"
          height="500"
          style={{ border: 0 }}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Kigali City Masterplan"
        />
        // {/* <MasterPlan /> */}
      {/* </div> */}

      <div className="mb-6">
        <h3 className="text-base font-medium text-gray-800 mb-3">
          🗺️ Property Location
        </h3>
        <PropertyMap
          Upi={formData.upi || ""}
          location={[
            formData?.latitude || 1.88596,
            formData?.longitude || 30.129675,
          ]}
        />
        <div className="grid grid-cols-1 gap-4 md:gap-8 mt-6">
          <div className="bg-gray-50 rounded-lg p-4">
            <h4 className="text-sm font-medium text-gray-700 mb-2">
              Google Maps View
            </h4>
            <iframe
              src={`https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.979567234864!2d${
                formData?.longitude || 0
              }!3d${
                formData?.latitude || 0
              }!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjM6MTM0!5e0!3m2!1sen!2sng!4v1680879000000!5m2!1sen!2sng`}
              width="100%"
              height="400"
              style={{ border: 0, borderRadius: "8px" }}
              allowFullScreen={false}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
          <div className="bg-gray-50 rounded-lg p-4">
            <h4 className="text-sm font-medium text-gray-700 mb-2">
              Kigali City Masterplan
            </h4>
            <iframe
              src="https://masterplan.kigalicity.gov.rw/portal/apps/webappviewer/index.html?id=fdd2e30cbc15401d9daee5f68982d755 "
              width="100%"
              height="500"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Kigali City Masterplan"
            />
          </div>
        </div>
      </div>
      <ComparativeAnalysis />
    </div>
  );
};

export default Step3Form;
